var map = {
	"./agility.png": "ebf5",
	"./health.png": "fcb1",
	"./yang atk.png": "5093",
	"./yang def.png": "2016",
	"./yin atk.png": "0c95",
	"./yin def.png": "1720"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "d6d6";